import { theme } from '@theme';
import { FC, useState } from 'react';
import styled from 'styled-components';
import { Icon } from '../../../style/Icon';
import { Typography } from '../../../style/Typography';

type UserProfileModalHeaderProps = {
  onCloseClick: () => void;
};

const UserProfileModalHeader: FC<UserProfileModalHeaderProps> = ({ onCloseClick }) => {
  const [hovered, setHovered] = useState<boolean>(false);
  const toggleHover = () => setHovered(!hovered);

  return (
    <Wrapper data-testid='modal-title'>
      <Typography
        size={theme.typography.h4}
        color={theme.palette.white}
        fontWeight={theme.typography.fontWeights.semibold}
        className='title'
      >
        Your Profile
      </Typography>
      <div>
        <ButtonWrapper
          data-testid='close-button'
          ishover={hovered}
          onClick={onCloseClick}
          type='button'
          onMouseEnter={toggleHover}
          onMouseLeave={toggleHover}
        >
          <Icon
            data-testid='close-icon'
            type='x'
            size={theme.typography.fontSize28}
            color={theme.palette.white}
            className='am-icon am-icon-x'
          />
        </ButtonWrapper>
      </div>
    </Wrapper>
  );
};

export default UserProfileModalHeader;

type ButtonWrapperProps = {
  ishover: boolean;
};

const Wrapper = styled.div`
  background-color: ${theme.palette.text.purple};
  display: flex;
  justify-content: space-between;
  border-radius: 6px 6px 0 0;
  overflow: hidden;
  height: 50px;
  .title {
    padding: 1em 1.26em;
  }
`;

const ButtonWrapper = styled.button<ButtonWrapperProps>`
  cursor: pointer;
  width: 60px;
  padding: 12px 12px;
  font-weight: ${theme.typography.fontWeights.semibold};
  border-left: 1px solid ${theme.palette.sidebarGradient.from};
  opacity: 1;
  background: ${(props) =>
    props.ishover ? theme.palette.hightLightPurple : theme.palette.text.purple};
`;
